import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

//* import the module auto exporter
//* modules will be auto exported and imported now
import modules from './modules';

// Plug Vuex into the Vue application
Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
  key: 'e6LocalStore',
  storage: window.localStorage,
  modules: ['shop'],
  reducer(state) {
    if (state?.authentication?.isAuthenticated === false || localStorage.getItem('ghostToken')) {
      return {};
    }
    return {
      shop: state.shop,
    };
  },
});

const vuexLocalUser = new VuexPersist({
  key: 'e6User',
  storage: window.localStorage,
  modules: ['users'],
  reducer(state) {
    if (state?.authentication?.isAuthenticated === false) {
      return {};
    }
    return {
      me: state?.users?.me,
    };
  },
});

// Initialize a new Vuex Store
export default new Vuex.Store({
  modules,
  plugins: [vuexLocalStorage.plugin, vuexLocalUser.plugin],
});
